export const SIDEBAR_TRANSITION = "width 300ms ease-in";
export const DISABLED_OPACITY = 0.4;
